import { Form } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';

import { IFieldUser } from '../../components/fieldUser';
import { ItemType, UserSelect } from '../../index';
import { RootState } from '../../store';

const GantFieldUser = <T extends Record<string, any>>({ disabled, name, label, mode }: IFieldUser<T>) => {
    const currentGantItem = useSelector<RootState, ItemType | null>((state) => state.gantItems.currentGantItem);

    return (
        <Form.Item<T> label={label} name={name as any}>
            <UserSelect
                disabled={disabled}
                mode={mode}
                onlyForProject={currentGantItem?.projectId ? [currentGantItem?.projectId] : []}
            />
        </Form.Item>
    );
};

export default GantFieldUser;
